// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"5be6b490","24":"2d088a90","81":"eef65a93","237":"e56211b6","462":"c88ecd88","463":"10ea32a6","594":"e83e03d2","619":"7c693b22","639":"eabb99b7","744":"bc1c67c6","775":"6500c7ab","885":"832acde2"}[chunkId] + ".chunk.js";
};